import { Capacitor } from '@capacitor/core';
import { format } from 'date-fns';
import { clarity } from 'react-microsoft-clarity';

import ENVIRONMENT from '@/environments/environment';
import { ClarityTaxonomyProps, ClientTaxonomyEvents, ClientTaxonomyProps } from '@/interfaces/AnalyticsInterface/AnalyticsInterface';

export const initializeClarity = async () => {
  if (Capacitor.getPlatform() === 'android') {
    // @ts-expect-error ClarityPlugin is according to documentation a global variable
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    declare let ClarityPlugin: any;
    ClarityPlugin.initialize(ENVIRONMENT.CLARITY_KEY, () => { }, () => { }, { isIonic: true });
  } else if (Capacitor.getPlatform() === 'web') {
    clarity.init(
      ENVIRONMENT.CLARITY_KEY_WEB!,
    );
  }
};

export const setClarityUserId = (merchantId: string) => {
  if (Capacitor.getPlatform() === 'android') {
    // @ts-expect-error ClarityPlugin is according to documentation a global variable
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    declare let ClarityPlugin: any;
    ClarityPlugin.setCustomUserId(merchantId, () => { }, () => { });
  } else if (Capacitor.getPlatform() === 'web') {
    clarity.setTag('user', merchantId);
  }
};
export const setClaritySessionId = (merchantId: string) => {
  const date = format(new Date(), 'yyyyMMdd');
  const customSessionId = `${merchantId}_${date}_${sessionStorage.getItem('accessToken')}`;

  if (Capacitor.getPlatform() === 'android') {
    // @ts-expect-error ClarityPlugin is according to documentation a global variable
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    declare let ClarityPlugin: any;
    ClarityPlugin.setCustomSessionId(customSessionId, () => { }, () => { });
  } else if (Capacitor.getPlatform() === 'web') {
    clarity.setTag('sessionId', customSessionId);
  }
};

type SetClarityCustomTagProps = Partial<Record<ClientTaxonomyProps | ClientTaxonomyEvents | ClarityTaxonomyProps, string>>;

export const setClarityCustomTags = async (prop: SetClarityCustomTagProps) => {
  const parsedProperties = Object.keys(prop).map((key) => ({
    name: key as ClientTaxonomyProps | ClientTaxonomyEvents | ClarityTaxonomyProps,
    value: prop[key as ClientTaxonomyProps | ClientTaxonomyEvents | ClarityTaxonomyProps] as string,
  }));

  if (Capacitor.getPlatform() === 'android') {
    // @ts-expect-error ClarityPlugin is according to documentation a global variable
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    declare let ClarityPlugin: any;

    parsedProperties.forEach(async (property) => {
      if (property.value) {
        ClarityPlugin.setCustomTag(property.name, property.value, () => { }, () => { });
      }
    });
  } else if (Capacitor.getPlatform() === 'web') {
    parsedProperties.forEach(async (property) => {
      if (property.value) {
        clarity.setTag(property.name, property.value);
      }
    });
  }
};
